import { hslToColorString, parseToHsl } from 'polished';
import { hslToHsv, hsvToHsl } from './';

/**
 * Applies an adjustment to a color based on the HSV/B or HSL color space.
 * By default this function will increase the delta. Setting <code>invert</code> to true will decrease the delta.
 * Conversion from https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion.
 *
 * @param color: string - color to adjust
 * @param background:string - color of the background
 * @param amount:number - amount to adjust the luminance [0, 100]
 * @param invert:boolean - invert the result. This is used to drecrease the luma delta if necessary.
 * @param useHsl:boolean - use the HSL color space for the transformation. This is currently used by our High Contrast theme.
 */
export const adjustLumaDelta = (color, background, amount, invert = false, useHsl = false) => {
  // Convert color to HSL
  const colorHSL = parseToHsl(color);
  const backgroundHSL = parseToHsl(background);

  // Convert HSL color to HSV
  const colorHSV = hslToHsv(colorHSL);
  const backgroundHSV = hslToHsv(backgroundHSL);

  // Check if the background is light or dark
  const lightBackground = backgroundHSV.value >= 0.5;
  const fractionalAmount = amount / 100;

  // Calculate the adjustment
  const delta = lightBackground ? -fractionalAmount : fractionalAmount;
  const adjustment = invert ? -delta : delta;

  // Make the adjustment to the color, then convert HSV color back to HSL if necessary because browsers support HSL and make sure values
  // don't escape proper bounds.
  const hsl = useHsl ? {
    hue: colorHSL.hue,
    saturation: colorHSL.saturation,
    lightness: Math.max(0, Math.min(1, colorHSL.lightness + adjustment))
  } : hsvToHsl({
    hue: colorHSV.hue,
    saturation: colorHSV.saturation,
    value: Math.max(0, Math.min(1, colorHSV.value + adjustment))
  });
  return hslToColorString(hsl);
};
//# sourceMappingURL=adjustLumaDelta.js.map